import React from 'react';
import { ChakraProvider } from "@chakra-ui/react";
import theme from "./theme";
import ReactDOM from 'react-dom/client';
import App from './App';

ReactDOM.createRoot(document.getElementById('root')).render(
 <ChakraProvider theme={theme}>
    <App />
  </ChakraProvider>
);
